import React, { FunctionComponent } from 'react';

import styles from './CampaignLogo.scss';
import useBasePageQuery from '../../hooks/useBasePageQuery';

export const CampaignLogo: FunctionComponent = () => {
  const basePageData = useBasePageQuery();

  if (!basePageData.data?.page) {
    return null;
  }

  const { logo, branding } = basePageData.data.page;

  const logoPath = Boolean(branding?.logo) ? branding?.logo : logo;

  return (
    <div className={styles.logoWrapper} data-qa="campaignLogo">
      <img
        className={styles.logoImage}
        src={`${logoPath}?template=size120x120`}
        alt=""
      />
    </div>
  );
};

export default CampaignLogo;
